import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_100_26027)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.8188 13.6364C15.8188 12.4314 16.7956 11.4545 18.0006 11.4545C19.2056 11.4545 20.1824 12.4314 20.1824 13.6364C20.1824 14.8413 19.2056 15.8182 18.0006 15.8182C16.7956 15.8182 15.8188 14.8413 15.8188 13.6364ZM18.0006 10C15.9923 10 14.3642 11.6281 14.3642 13.6364C14.3642 15.6447 15.9923 17.2727 18.0006 17.2727C20.0089 17.2727 21.637 15.6447 21.637 13.6364C21.637 11.6281 20.0089 10 18.0006 10ZM16.546 18.7273C13.7344 18.7273 11.4551 21.0065 11.4551 23.8182C11.4551 25.0232 12.4319 26 13.6369 26H22.3643C23.5693 26 24.5461 25.0232 24.5461 23.8182C24.5461 21.0065 22.2668 18.7273 19.4552 18.7273H16.546ZM12.9096 23.8182C12.9096 21.8099 14.5377 20.1818 16.546 20.1818H19.4552C21.4635 20.1818 23.0916 21.8099 23.0916 23.8182C23.0916 24.2199 22.766 24.5455 22.3643 24.5455H13.6369C13.2353 24.5455 12.9096 24.2199 12.9096 23.8182Z",
			fill: "black"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_100_26027",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(10 10)"
		})
	}) })]
});
export default SvgUser;
